import React from 'react';
import * as S from './styles';
import { IconInfo, InlineNotification } from '@veneer/core';
import { primitives } from '@veneer/primitives';
import { useTranslationWithInterpolation } from 'src/hooks/useTranslationWithValues/useTranslationWithValuesHelper';
import { HPprinter, HPink } from 'src/assets/images';
import { PrinterItem } from 'src/utils/Products/productFilter';

const { color } = primitives;

interface UpgradeDetailsOnlyProps {
  selectedPrinterDetails: PrinterItem;
  isPlanChangeDone: boolean;
}

const UpgradeDetailsOnly: React.FC<UpgradeDetailsOnlyProps> = ({
  selectedPrinterDetails,
  isPlanChangeDone
}) => {
  const { getText, getTextWithValues } = useTranslationWithInterpolation();
  const recommendedInkPlan = selectedPrinterDetails?.inkPlan.find(
    (plan) => plan.recommendedPlan
  );
  const printerModel = selectedPrinterDetails?.printerName;
  const pages = recommendedInkPlan?.pagesPerMonth;

  return (
    <S.DetailsCard>
      <S.DetailsCardTitleAndSubtitle>
        <S.DetailsCardTitle>
          {' '}
          {getText(
            'confirmation.successMessage',
            "You've successfully upgraded to this new plan."
          )}
        </S.DetailsCardTitle>
        <S.DetailsCardSubtitle>
          {' '}
          {getText(
            'confirmation.description',
            'Your subscription will begin once the printer ships to you.'
          )}
        </S.DetailsCardSubtitle>
        {isPlanChangeDone && (
          <S.DetailsCardSubtitle>
            {getText(
              'confirmation.description2',
              'The plan change you requested before making the upgrade process will be lost and replaced with this new one.'
            )}
          </S.DetailsCardSubtitle>
        )}
      </S.DetailsCardTitleAndSubtitle>
      <S.SubscriptionPlanItems>
        <S.ItemSection>
          <S.ImageSection>
            <S.ItemImage
              src={selectedPrinterDetails?.thumbnailImage || HPprinter}
              alt={printerModel}
            />
          </S.ImageSection>
          <S.ItemTitle>{printerModel}</S.ItemTitle>
        </S.ItemSection>
        <S.ItemSection>
          <S.ImageSection>
            <S.ItemImage
              src={HPink}
              alt="HP Ink"
            />
          </S.ImageSection>
          <S.ItemTitle>
            {getTextWithValues(
              'confirmation.printerPages',
              `Print plan: {{pages}} pages/month`,
              {
                pages: pages
              }
            )}
          </S.ItemTitle>
        </S.ItemSection>
        <S.PlanNotification>
          <InlineNotification
            description={getText(
              'confirmation.planBadge',
              'You can adjust your print plan once you have setup your new upgrade printer.'
            )}
            type="custom"
            icon={
              <S.IconNotification>
                <IconInfo filled />
              </S.IconNotification>
            }
            customStyle={{
              color: color.electricBlue7,
              backgroundColor: color.electricBlue0
            }}
            closeButton={false}
          />
        </S.PlanNotification>
      </S.SubscriptionPlanItems>
    </S.DetailsCard>
  );
};

export default UpgradeDetailsOnly;
